/**
 * Format the phone number to E.164 format
 * @param phone - The phone number to format
 * @returns The formatted phone number
 */
export const formatPhoneToE164 = (phone: string): string => {
  const sanitized = phone.replace(/\D/g, '');
  if (sanitized.length === 11 && sanitized.startsWith('1')) {
    return `+${sanitized}`;
  }
  if (sanitized.length === 10) {
    return `+1${sanitized}`;
  }
  if (phone.startsWith('+')) {
    return phone;
  }
  return `+1${sanitized}`;
};
